import { css, styled } from 'styled-components';

export const StyledRow = styled.div<{ $gap: number; $reversed: boolean }>`
  ${({ $gap, $reversed }) => css`
    display: flex;
    flex-direction: ${$reversed ? 'row-reverse' : 'row'};
    flex-wrap: wrap;
    min-width: 100%;
    margin-left: ${$gap / -2}px;
    margin-right: ${$gap / -2}px;
  `}
`;
